/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerPayoutConfig } from '../../config/header.config';

export interface IHeaderPayoutPluginMethods extends IPluginMethodMap {
  getHeaderPayoutSync(args?: any): any;
}

export class HeaderPayoutPlugin implements IAgentPlugin {
  readonly methods: IHeaderPayoutPluginMethods;

  constructor() {
    this.methods = {
      getHeaderPayoutSync: this.getHeaderPayoutSync.bind(this),
    };
  }

  getHeaderPayoutSync(args?: any) {
    return {
      header: headerPayoutConfig,
    };
  }
}
